<template>
    <div id="replyInvite">
        <my-header></my-header>
        <div class="banner">
            <img src="../../../assets/images/invitemanage/topBg.jpg"/>
            <div class="main-container">
                <div class="bannerText">
                    <h2>【{{ detailData.flowCode }}】{{ detailData.purchaseItemName || '' }}<span>回复邀请函</span></h2>
                </div>
            </div>
        </div>
        <div class="main-container mainWrap">
            <section class="small-container">
                <h2 style="font-size:24px;">北大资源集团</h2>
                <h2>
                    <img src="../../../assets/images/invitemanage/tit.png"/>
                </h2>
                <div class="article">
                    <div class="subtitle">
                        <h3><span>致</span>{{ companyName  }}</h3>
                        <!--<h3><span>有关</span>{{ detailData.purchaseItemName }}</h3>-->
                    </div>
                    <p class="paragraph1">诚邀贵司参与北大资源集团【{{ detailData.flowCode || '' }} -- {{ detailData.purchaseItemName || '' }}】招投标活动，如确认参与投标，请在<strong>{{ detailData.signDeadline }}</strong>前报名，并按要求补充相关资料。 </p>
                    <p class="paragraph2">招标联系人：【{{  detailData.tenderAgentName}}】 联系方式：【{{ detailData.tenderAgentPhone }}】</p>
                    <p>如官网操作有任何疑问，请查看官网<span @click="toHelp" class="toHelp" > 帮助中心</span>。</p>
                </div>
            </section>
            <div class="bottomBtns" v-if="$route.params.entrance == 1">
                <el-button class="cancelBtn" @click="no">不参与</el-button>
                <el-button type="primary" style="padding: 10px 40px;font-size: 14px;" @click="yes">参与</el-button>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    import MyHeader from '../MasterHeader.vue';
    export default {
        name: 'replyInvite',
        data() {
            return {
                companyName: window.sessionStorage.getItem('companyName'),
                cancelId: '',//跳转的id
                status: 0,//是否参与 回复邀请函 1 不同意 2 同意
               detailData: {
                   signDeadline: '',
               } //详情数据
            }
        },
        components: {MyHeader},
        created(){
            this.$root.activeIndex = 'win';
            let that = this;
            this.$root.getHttp('/v1/outerformflow/invitationDetail?formId='+ this.$route.params.formId,function (res) {
                that.detailData = res.data.data.flowResponse;
                that.cancelId = res.data.data.dealBisVo.flowFormExtMng.id;
            })
        },
        methods: {
            no(){//不参与
                this.status = 1;
                let that = this;
                function cancel() {
                    that.$message({
                        message: '您没有参与投标！',
                        type: 'warning'
                    });
                }
                this.submit(cancel);
            },
            yes(){
                this.status = 2;
                let that = this;
                function success(){
                    that.$message({
                        message: '您已成功回复邀请函！',
                        type: 'success'
                    });
                }
                this.submit(success);
            },
            submit(fn){//参与
                let that = this;
                this.$root.postHttp('/v1/outerformflow/invitationReply',{
                    agreeFlag: that.status,
                    formId: that.$route.params.formId
                },function (res) {
//                    console.log(res)
                    fn && fn();
                    setTimeout( () => {
                        that.$router.push('/master/processManagement/'+that.cancelId+'/1');
                    },1000)
                })
            },
            toHelp(){
                this.$root.activeIndex = 'setting';
                this.$router.push('/help');
            },
        }
    }
</script>
<style lang="scss">
@import "../../../assets/var";
#replyInvite {
    padding: 80px 0 50px;
    min-height: 85vh;
    background: $--primary-fill-color;
    & .head-top{
        background: #fff;
    }
    & .head-right {
        color: $--text-color-light;
        & .login {
            background: url('../../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
        }
        & .register {
            background: url('../../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
        }
        & .line {
            background: $--text-color-light;
        }
        & .help {
            background: url('../../../assets/images/topBar2/icon05.png') no-repeat;
        }
        & .wechat {
            background: url('../../../assets/images/topBar2/icon06.png') no-repeat;
        }
    }
    .banner {
        img {
            width: 100%;
            min-width:1300px;
            height: 140px;
        }
        .main-container {
            position: relative;
            .bannerText {
                position: absolute;
                left: 0;
                top: -50px;
                width: 100%;
                color: #fff;
                line-height: 34px;
                h2 {
                    float: left;
                    font-size: 18px;
                    span {
                        display: inline-block;
                        vertical-align: middle;
                        border: 1px solid #fff;
                        padding: 0 8px;
                        margin-left: 15px;
                        height: 24px;
                        font-size: 14px;
                        line-height: 22px;
                        border-radius: 4px;
                        font-weight: normal;
                        box-sizing: border-box;
                    }
                }
                p {
                    float: right;
                    font-size: 14px;
                }
            }
        }
    }
    .mainWrap {
        position: relative;
        margin-top: 40px;
        padding-bottom: 90px;
        background: #fff;
    }
    .small-container {
        padding: 70px;
        h2 {
            margin-top: 20px;
            img {
                width: 286px;
                height: 50px;
            }
        }
        .article {
            margin-top: 50px;
            text-align: left;
            font-size: 14px;
            line-height: 34px;
        }
        .subtitle {
            h3 {
                display: inline-block;
                vertical-align: middle;
                margin-right: 150px;
                span {
                    display: inline-block;
                    margin-right: 10px;
                    width: 40px;
                    text-align: center;
                    color: #fff;
                    border-radius: 3px;
                    background: $--primary-color;
                }
            }
        }
        .paragraph1,
        .paragraph2 {
            margin-top: 45px;
        }
        .list {
            color: #000;
        }
    }
    .bottomBtns{
          margin: 40px 0 0;
          .cancelBtn {
              padding: 10px 40px;
              font-size: 14px;
              background: #cfcfcf;
          }
          .cancelBtn:hover,
          .cancelBtn:focus {
              border-color: #cfcfcf;
              color: #fff;
          }
      }
    .toHelp {
        color: #666;
        font-weight: 700;
        cursor: pointer;
    }
    .toHelp:hover {
        text-decoration: underline;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/master/inviteProcess/ReplyInvite.vue